import { type AncillariesState } from '~shared/reducers/ancillaries';
import { type ReduxStateShared } from '~shared/types';

export const getAncillaries: (arg0: ReduxStateShared) => AncillariesState = (state) => state.ancillaries || [];
